import { type ClassValue, clsx } from "clsx";
import { useParams } from "react-router";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function reorder<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

/**
 * For when you need an async placeholder function
 */
export function asyncNoop<Params extends any[]>(...args: Params) {
  return Promise.resolve();
}

type Unit = "bytes" | "KB" | "MB" | "GB" | "TB";
const UNITS: Unit[] = ["bytes", "KB", "MB", "GB", "TB"];
export function convertBytes(value: number, to: Unit): number {
  const toIndex = UNITS.indexOf(to);
  const factor = Math.pow(1024, toIndex);
  const convertedValue = value / factor;
  // Rounding to 2 decimal places
  return Math.round(convertedValue * 100) / 100;
}

export function bytesToString(value: number): string {
  const unitIndex = Math.floor(Math.log(value) / Math.log(1024));
  const unit = UNITS[unitIndex];
  const convertedValue = convertBytes(value, unit);
  return `${convertedValue} ${unit}`;
}

export const useRequiredParams = <T extends Record<string, string>>() => useParams() as T;

export const convertToCamelCase = (str: string) => str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
